/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TurnMeUp from '../common/TurnMeUp.js';
import PlayPauseButtons from '../common/PlayPauseButtons.js';

const HearMeItem = ({track, actions, roleID, showArtistName}) => { 
    const playPause = (event) => {
        event.preventDefault();
        actions.playPauseTrack(track.ID);
    };

    return (
        <div className="songblock">
            <PlayPauseButtons trackID={track.ID} anchorClass="btn-play btn-play-dark play transition2" spanClass="circ transition" playButtonClass="icon icn-play transition" pauseButtonClass="icon icn-pause transition" /> 
            <div className="songblock-info">
                <h5><a href="#" className="transition link" style={{color: '#333'}} onClick={playPause}>{track.Name}</a> <span className="songblock-dur">{`(${track.LengthMins}:${(track.LengthSecs + '').padStart(2, '0')})`}</span></h5>
                {
                    showArtistName ? 
                        <p className="by">
                            By: <Link to={`/${track.RoleUsername}`} className="transition link" style={{color: '#333'}}>{track.RoleDisplayName}</Link>
                        </p> 
                        : null
                } 
            </div>
            <div className="songblock-actions">
                <div className="item-turnup">
                    <TurnMeUp id={track.ID} rating={track.Rating} roleID={track.RoleID || roleID} isMusic />
                </div>
            </div>
            <div className="songblock-long">
                <p className="songblock-desc">{track.Description}</p>
            </div>
        </div>
    );
};

HearMeItem.propTypes = {
    track: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    roleID: PropTypes.number
};

export default HearMeItem;